
import * as React from 'react';
import GroupPaxsView from './paxs.view';
import { ContextService } from 'src/core/services/context.service';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { ToastNotifications } from 'src/core/ui/toast';
import { resolve } from 'inversify-react';
import { DataLocalService } from 'src/core/services/data-local.service';
import { BookemZulu } from 'src/core/services/data/JayDataContext';
import { ObjectUtils } from 'src/core/utils/object';
import { QuotePaxDataService } from 'src/app/bookings/quote-paxs/quote-pax-form.data';


interface IGroupPaxsControllerProps {
	contextService: ContextService;
	groupId: number;
	setBusy: (isBusy: boolean) => void;
	onLoadData: (count: number) => void;
}

interface IGroupPaxsControllerState {
	quotes: { [quoteNumber: string]: QuotePaxItem[] };
}

@observer
export default class GroupPaxsController extends React.Component<IGroupPaxsControllerProps, IGroupPaxsControllerState>{


	@observable
	mapService: QuotePaxDataService;

	@observable
	dataService: DataSet<QuotePaxItem>;

	@resolve
	toast: ToastNotifications;


	constructor(props: any) {
		super(props);

		this.state = {
			quotes: {}
		}
	}

	public componentDidMount() {
		this.mapService = QuotePaxDataService.make(this.props.contextService);

		this.loadPaxs();
	}

	loadPaxs = async () => {

		this.props.setBusy(true)

		try {

			var data = await (await this.props.contextService.current()).GetGroupPaxs(this.props.groupId);

			var summaries = await data.toArray();
			
			this.props.onLoadData(summaries.length);

			this.groupPaxs(summaries);
		}
		catch (e) {
			this.toast.showToast("Error", ObjectUtils.parseError(e), "error");
		}
		finally {
			this.props.setBusy(false);
		}
	}

	groupPaxs = (summaries: any[]) => {
		let groups = {};

		for (let quote of summaries) {
			const previous = !groups[quote.quoteNumber] ? [] : groups[quote.quoteNumber];

			groups[quote.quoteNumber] = [...previous, this.mapService.map(quote)];
		}

		
		this.setState({ quotes: groups });
	}

	render() {

		if (Object.getOwnPropertyNames(this.state.quotes).length == 0)
			return null;

		return <GroupPaxsView
				quotes={this.state.quotes}
				{...this.props}
		/>;
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/parts/paxs.controller.tsx